import { Redirect, Route } from 'react-router-dom';

const ProtectedRoute = props => {
  let loginDetails = null;

  try {
    const credentialsString = localStorage.getItem('credentials');
    if (credentialsString) {
      loginDetails = JSON.parse(credentialsString);
    }
  } catch (error) {
    console.error('Failed to parse credentials from localStorage:', error);
    localStorage.removeItem('credentials');
    loginDetails = null;
  }

  const loginTimeStamp = localStorage.getItem('loginTimeStamp');

  // 8 hours = 28800000 ms (full workday session — prevents data loss during long edits)
  if (!loginDetails || !loginTimeStamp || (Date.now() - loginTimeStamp) > 28800000) {
    localStorage.removeItem('credentials');
    localStorage.removeItem('loginTimeStamp');
    return <Redirect to='/login' />;
  }
  return <Route {...props} />;
};

export default ProtectedRoute;
